module.exports = __webpack_public_path__ + "img/elementheights_jakp.a5882606.png";